export default {
  init() {
    // JavaScript to be fired on all pages

    // Toggle class for navbar toggle
    $('#menu').on('show.bs.collapse', function() {
      $('body').addClass('has-visible-nav');
    });

    $('#menu').on('hidden.bs.collapse', function() {
      $('body').removeClass('has-visible-nav');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
